import { render, staticRenderFns } from "./Reviewers.vue?vue&type=template&id=316164e2&scoped=true"
import script from "./Reviewers.vue?vue&type=script&lang=js"
export * from "./Reviewers.vue?vue&type=script&lang=js"
import style0 from "./Reviewers.vue?vue&type=style&index=0&id=316164e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316164e2",
  null
  
)

export default component.exports